import { Navigate, Outlet } from 'react-router-dom';

import { useAuthStore } from '@/stores/auth';

import type { ReactNode } from 'react';

export function AuthGuard(): ReactNode {
  const { isAuthenticated, isLoading } = useAuthStore();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-void flex items-center justify-center">
        <p className="text-muted text-sm">Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
